import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
// import { useState } from 'react';
// import ClassCardTour from './components/ClassCardTour';
// import CompletedTour from './components/CompleletedTour';
// import NavBarTour from './components/NavBarTour';
// import Welcome from './components/Welcome';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
// import KeyboardTabIcon from '@mui/icons-material/KeyboardTab';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Typography } from '@mui/material';
import assessmentIcon from '../../../assets/images/OnlineAssessmentIcon.png';

const t = (key) => translate('ui', key);

const HomeTourModal = (props: { closeModal: any }) => {
  // const [tourStep, setStep] = useState<number>(0);
  const classes = useStyles();

  // const displayTourStep = (step: number) => {
  //   switch (step) {
  //     case 0:
  //       return <Welcome />;

  //     case 1:
  //       return <NavBarTour />;

  //     case 2:
  //       return <ClassCardTour />;

  //     case 3:
  //       return <CompletedTour />;

  //     default:
  //       return <div>Uh oh</div>;
  //   }
  // };

  return (
    <div className={classes.welcome}>
      <div className={classes.edPkt}>
        <Paper>
          <ArrowForwardIcon />
          <Typography variant="h2">{t('tour.educationPackets')}</Typography>
        </Paper>
      </div>
      <div className={classes.homeLink}>
        <Paper>
          <ArrowForwardIcon />
          <Typography variant="h2">{t('tour.home')}</Typography>
        </Paper>
      </div>
      <div className={classes.classLink}>
        <Paper>
          <ArrowForwardIcon />
          <Typography variant="h2">{t('tour.class')}</Typography>
        </Paper>
      </div>
      {/* <div className={classes.pliLink}>
        <ArrowForwardIcon />
        <Typography variant="h2">
          Use the PLI link to manage classrooms, students and licenses
        </Typography>
      </div> */}
      <div className={classes.tourModal}>
        <img className={classes.icon} src={assessmentIcon} alt="Assessment Icon" />
        <Typography variant="h1">{t('tour.welcome')}</Typography>

        <Typography variant="body1">{t('tour.development')}</Typography>
        <ul>
          <li>
            <Typography variant="body1">{t('tour.downloadPackets')}</Typography>
          </li>
          <li>
            <Typography variant="body1">{t('tour.downloadAssessment')}</Typography>
          </li>
          <li>
            <Typography variant="body1">{t('tour.recordScores')}</Typography>
          </li>
          <li>
            <Typography variant="body1">{t('tour.viewReports')}</Typography>
          </li>
          <li>
            <Typography variant="body1">{t('tour.implementRemediation')}</Typography>
          </li>
        </ul>
        <Button variant="contained" onClick={props.closeModal}>
          {t('tour.getStarted')}
        </Button>
        {/* <Button variant="contained" onClick={props.closeModal}>
          {t('tour.instructionalVideo')}
        </Button> */}
        <div style={{ clear: 'both' }}></div>
      </div>
      {/* {displayTourStep(tourStep)} */}
      {/* <div className={classes.flexBetween}>
        {tourStep < 3 && (
          <Button onClick={props.closeModal}>
            <KeyboardTabIcon />
            {t('tour.skip')}
          </Button>
        )}
        <div className={classes.flexEnd}>
          {tourStep > 0 && (
            <Button onClick={() => setStep(tourStep - 1)}>
              <ArrowBackIcon />
              {t('tour.previous')}
            </Button>
          )}
          {tourStep < 3 ? (
            <Button onClick={() => setStep(tourStep + 1)}>
              <ArrowForwardIcon />
              {t('tour.next')}
            </Button>
          ) : (
            <Button onClick={props.closeModal}>
              <ArrowForwardIcon />
              {t('tour.complete')}
            </Button>
          )}
        </div>
      </div> */}
    </div>
  );
};

export default HomeTourModal;

const useStyles = makeStyles((theme: Theme) => {
  return {
    welcome: {
      '& h2': {
        color: 'white',
      },
    },
    tourModal: {
      background: 'white',
      padding: theme.spacing(4),
      '& p': {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
      },
      '& .MuiButton-root': {
        borderRadius: '100px',
        float: 'right',
      },
      minWidth: '40vw',
      maxWidth: '400px',
    },
    edPkt: {
      position: 'fixed',
      width: '45%',
      top: '5%',
      right: '1%',
      '& .MuiTypography-root': {
        color: 'black',
      },
      '& .MuiSvgIcon-root': {
        display: 'block',
        marginLeft: '80%',
        color: 'black',
        fontSize: '2rem',
        transform: 'rotate(270deg)',
      },
    },
    homeLink: {
      position: 'fixed',
      top: '5%',
      left: '1%',
      '& .MuiTypography-root': {
        color: 'black',
      },
      '& .MuiSvgIcon-root': {
        display: 'block',
        color: 'black',
        fontSize: '2rem',
        left: 0,
        transform: 'rotate(270deg)',
      },
    },
    classLink: {
      position: 'fixed',
      width: '25%',
      top: '30%',
      left: '3%',
      '& .MuiTypography-root': {
        color: 'black',
      },
      '& .MuiSvgIcon-root': {
        display: 'block',
        marginLeft: '50%',
        color: 'black',
        fontSize: '2rem',
        transform: 'rotate(270deg)',
      },
    },
    pliLink: {
      position: 'fixed',
      width: '50%',
      bottom: '5%',
      right: '10%',
      '& .MuiSvgIcon-root': {
        position: 'absolute',
        color: 'white',
        fontSize: '2rem',
        right: '5%',
        transform: 'rotate(270deg)',
      },
      '& h2': {
        marginTop: theme.spacing(6),
      },
    },
    icon: {
      display: 'block',
      margin: 'auto',
      width: '15%',
    },
  };
});
